import React, { Suspense, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
// import PropertySections from "../../components/templates/property/sections/PropertySections";
import { Fancybox } from '@fancyapps/ui/dist/fancybox.esm';
import { config } from '@fortawesome/fontawesome-svg-core';
import Redis from 'ioredis'
import MobileDetect from 'mobile-detect';
import dynamic from 'next/dynamic';

import Addons from '../../components/Addons';
import * as appContext from '../../components/AppContext';
import BuilderHead from '../../components/head/BuilderHead';
import { InlineStyles } from '../../components/templates/index/partials/InlineStyles';
import Checkers from '../../helpers/class/Checkers';
import * as DataFetchHelper from '../../helpers/DataFetchHelper';
import * as MethodHelper from '../../helpers/MethodHelper';
import { setIsDesktop, setIsMobile, setIsTablet } from '../../redux/actions';
import { wrapper } from '../../redux/store';

import '@fortawesome/fontawesome-svg-core/styles.css';

config.autoAddCss = false;

const PropertySections = dynamic( () => import( '../../components/templates/property/sections/PropertySections' ), { suspense: true });
const Scripts = dynamic( () => import( '../../components/Scripts' ), { ssr: false });
const PropertyScripts = dynamic( () => import( '../../components/PropertyScripts' ), { ssr: false });


export default function PropertyComponent ( props ) {

  const isDesktop = useSelector( state => state['appSettings']['isDesktop']);

  const app = props.app;
  const head = props.head;
  const content = props.content;
    
  const all_images = props.all_images;
  const features = props.features;
  const builder = props.builder;
  const footer = props.footer;

  const app_data = props.app_data;
  const locations = props.locations;
  const navigation = props.navigation;

  const captchaSiteKey = '6Ldn5jYUAAAAAHV8v0apDoa8Hd1O67fo92WqpWRY';

  return (
    <>
      <Suspense>
        <PropertySections
          key={2}
          isDesktop={isDesktop}
          app_data={app_data}
          head={head}
          app={app}
          builder={builder}
          navigation={navigation}
          content={content}
          locations={locations}
          footer={footer}
          captchaSiteKey={captchaSiteKey}
          all_images={all_images}
          features={features}
          page_title={content.page_title}
          phone={(head.location[0].phoneCountryCode!=undefined ? ("+" + head.location[0].phoneCountryCode) : "+30") + " " + head.location[0].phone}
          removeHeader={props.removeHeader}
        />
      </Suspense>
      <Scripts key={3}/>
      <PropertyScripts key={4}/>
      <Addons
        key={5}
        script_sections={null} />
    </>
  )
}